import { render, staticRenderFns } from "./QuotationReport.vue?vue&type=template&id=ece5ecaa&scoped=true"
import script from "./QuotationReport.vue?vue&type=script&lang=js"
export * from "./QuotationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece5ecaa",
  null
  
)

export default component.exports